import React from "react";
import telegramService from "../../utils/telegram";

type CardVariant = "default" | "elevated" | "warm" | "glass";
type CardPadding = "none" | "sm" | "md" | "lg";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  padding?: CardPadding;
  interactive?: boolean;
}

const VARIANT_CLASSES: Record<CardVariant, string> = {
  default: "bg-surface border border-line shadow-card",
  elevated: "bg-surface border border-line shadow-elevated",
  warm: "bg-surface-warm border border-brand-soft-2 shadow-soft",
  glass: "bg-surface-elevated backdrop-blur-xl border border-line shadow-card",
};

const PADDING_CLASSES: Record<CardPadding, string> = {
  none: "",
  sm: "p-3",
  md: "p-4",
  lg: "p-5",
};

const Card: React.FC<CardProps> = ({
  variant = "default",
  padding = "md",
  interactive = false,
  className = "",
  children,
  onClick,
  ...rest
}) => {
  const handleClick = onClick
    ? (e: React.MouseEvent<HTMLDivElement>) => {
        telegramService.haptic("light");
        onClick(e);
      }
    : undefined;

  return (
    <div
      onClick={handleClick}
      className={`rounded-3xl transition-all duration-200
        ${VARIANT_CLASSES[variant]} ${PADDING_CLASSES[padding]}
        ${interactive || onClick ? "cursor-pointer hover:shadow-card-hover active:scale-[0.985]" : ""}
        ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card;
